var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovalFlowSubmittedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#16D264"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 16C31 18.7614 28.7614 21 26 21C23.2386 21 21 18.7614 21 16C21 13.2386 23.2386 11 26 11C28.7614 11 31 13.2386 31 16Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7273 11C15.4661 11 13.8355 11 12.7031 11.7978C12.3786 12.0264 12.0906 12.2975 11.8477 12.6029C11 13.6687 11 15.2034 11 18.2727V20.8182C11 23.7814 11 25.2629 11.4689 26.4462C12.2228 28.3486 13.8171 29.8491 15.8384 30.5586C17.0956 31 18.6698 31 21.8182 31C23.6173 31 24.5168 31 25.2352 30.7478C26.3902 30.3424 27.3012 29.4849 27.732 28.3979C28 27.7217 28 26.8751 28 25.1818V24.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16.5C24 16.5 24.5 16.5 25 17.5C25 17.5 26.5882 15 28 14.5",
    stroke: "#16D264",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21C11 22.8409 12.4924 24.3333 14.3333 24.3333C14.9991 24.3333 15.784 24.2167 16.4314 24.3901C17.0065 24.5442 17.4558 24.9935 17.6099 25.5686C17.7833 26.216 17.6667 27.0009 17.6667 27.6667C17.6667 29.5076 19.1591 31 21 31",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalFlowSubmittedIcon);
export default __webpack_public_path__ + "static/media/approval-flow-submitted-icon.10d264f63ee2d5bf825be001c83f8fbe.svg";
export { ForwardRef as ReactComponent };